'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FitToWindow = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _debounce = require('./debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getViewportDimensions() {
  return {
    windowWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    windowHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  };
}

var FitToWindow = exports.FitToWindow = function (_React$Component) {
  _inherits(FitToWindow, _React$Component);

  function FitToWindow(props) {
    _classCallCheck(this, FitToWindow);

    var _this = _possibleConstructorReturn(this, (FitToWindow.__proto__ || Object.getPrototypeOf(FitToWindow)).call(this, props));

    _this.state = getViewportDimensions();
    _this.handleWindowResize = (0, _debounce2.default)(_this.handleWindowResize, 100).bind(_this);
    return _this;
  }

  _createClass(FitToWindow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var scale = 1,
          style = {};

      if (this.props.fit) {
        var _state = this.state,
            windowWidth = _state.windowWidth,
            windowHeight = _state.windowHeight;
        var _props = this.props,
            width = _props.width,
            height = _props.height;


        if (width !== windowWidth && height !== windowHeight) {
          var scaleX = windowWidth / width,
              scaleY = windowHeight / height;

          scale = windowWidth / windowHeight > width / height ? scaleY : scaleX;
        }

        style = {
          transform: 'scale(' + scale + ')',
          transformOrigin: '0 0',
          width: width + 'px',
          height: height + 'px'
        };
      }

      return _react2.default.createElement(
        'div',
        { ref: 'wrapper', className: this.props.className, style: style },
        this.props.children
      );
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      this.setState(getViewportDimensions());
    }
  }]);

  return FitToWindow;
}(_react2.default.Component);

FitToWindow.defaultProps = {
  fit: true
};


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/FitToWindow.js
// module id = 135
// module chunks = 0